import { render, staticRenderFns } from "./tambahpenebangan.vue?vue&type=template&id=7af42e89&"
import script from "./tambahpenebangan.vue?vue&type=script&lang=js&"
export * from "./tambahpenebangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports